import {apiSave, apiDeleteSave} from '@/api/government'
import store from '@/store'
import {Message} from 'element-ui';

// 点击调用动画效果
export function animateCSS(element, animation, prefix = 'animate__') {
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const node = document.querySelector(element);

    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      resolve('Animation ended');
    }

    node.addEventListener('animationend', handleAnimationEnd, {once: true});
  })
}


// logo header 部分配置
export function logoHeaderOption(key, param) {
  const option = [
    {name: '首页', path: '/Home', logo: 'home/main_logo.png', logoWidth: 650, logoTop: 30, style: '', isSearch: true},
    {
      name: '政务服务',
      path: '/government',
      logo: 'government/logo.png',
      logoWidth: 350,
      logoTop: 20,
      style: 'style2',
      isSearch: false
    },
    {
      name: '数据分析',
      path: '/logisticsBigData',
      logo: 'logisticsBigData/logo.png',
      logoWidth: 350,
      logoTop: 20,
      style: 'style6',
      isSearch: false
    },
    {
      name: '垂直产业',
      path: '/industryCenter',
      logo: 'industryCenter/logo.png',
      logoWidth: 350,
      logoTop: 20,
      style: 'style2',
      isSearch: false
    },
    {
      name: '数智物流',
      path: '/logistics',
      logo: 'logistics/logo.png',
      logoWidth: 350,
      logoTop: 20,
      style: 'style2',
      isSearch: false
    },
    {
      name: '供应链金融',
      path: '/supplyFinance',
      logo: 'supplyFinance/logo.png',
      logoWidth: 350,
      logoTop: 20,
      style: 'style2',
      isSearch: false
    },
    {
      name: '应用云平台',
      path: '/supplychain',
      logo: 'supplychain/logo.png',
      logoWidth: 350,
      logoTop: 20,
      style: 'style5',
      isSearch: false
    },
    {
      name: '反馈留言',
      path: '/mesuggestions',
      logo: 'home/main_logo.png',
      logoWidth: 650,
      logoTop: 30,
      style: 'style3',
      isSearch: true
    },
    {
      name: '新闻中心',
      path: '/newsCenter',
      logo: 'home/main_logo.png',
      logoWidth: 650,
      logoTop: 30,
      style: 'style4',
      isSearch: true
    },
    {
      name: '关于我们',
      path: '/about',
      logo: 'home/main_logo.png',
      logoWidth: 650,
      logoTop: 30,
      style: 'style4',
      isSearch: true
    },
    {
      name: '网站申明',
      path: '/websitestated',
      logo: 'home/main_logo.png',
      logoWidth: 650,
      logoTop: 30,
      style: 'style3',
      isSearch: true
    },
    // {name: '帮助中心', path:'/helpCenter', logo: 'home/main_logo.png', logoWidth:650, logoTop:40, style:'', isSearch: true}
  ]

  let cc = option.filter(item => {
    return item.path === key
  })

  // 默认情况
  if (cc.length === 0) {
    cc = [option[0]]
  }

  if (param === 'logo') {
    return cc[0].logo
  } else if (param === 'style') {
    return cc[0].style
  } else if (param === 'isSearch') {
    return cc[0].isSearch
  } else if (param === 'logoWidth') {
    return cc[0].logoWidth
  } else if (param === 'logoTop') {
    return cc[0].logoTop
  } else {
    return param
  }

}

export function isMobile() {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent)
}

export function collect(data, flag) {
  return new Promise(async (resolve, reject) => {
    const userInfo = store.getters.userInfo
    console.log(userInfo)
    data.createBy = userInfo.YHBH
    if (!data.createBy){
      Message.warning('此功能需登录后使用！');
      reject()
      return
    }
    try {
      if (flag) {
        await apiSave(data)
      } else {
        await apiDeleteSave(data)
      }
      Message.success('操作成功');
      resolve()
    } catch (e) {
      console.log(e)
      Message.error('操作失败');
      reject()
    }
  })

}



// WEBPACK FOOTER //
// ./src/utils/index.js